import React from 'react'

import { number } from 'prop-types'

function NumberOfItems({ totalCount, perPage, currentPage }) {
  const startItem = (currentPage - 1) * perPage + 1
  const endItem = Math.min(currentPage * perPage, totalCount)

  return (
    <div className="shared-pagination__number-of-items">
      <span className="shared-pagination__count">
        {`Showing ${startItem}-${endItem} of ${totalCount}`}
      </span>
    </div>
  )
}

NumberOfItems.propTypes = {
  totalCount: number.isRequired,
  perPage: number.isRequired,
  currentPage: number.isRequired,
}

export default NumberOfItems
